import { formatCents } from '@src/common';
import { additionalTypeIsPerson } from '@src/common/additionals';
import type { Additional } from '@src/core/buyerApiClient';
import { Translate } from '@src/i18n/useTranslate';

export function formatPriceLine(additional: Additional, i18n: Translate['i18n']) {
  const price = formatCents(additional.priceCents);
  if (additionalTypeIsPerson(additional)) {
    return `${price} ${i18n('adder_additionals_perPerson')}`;
  }
  return price;
}
